import React from 'react';
import Icon from '../../../components/AppIcon';

const SupportStats = () => {
  const stats = [
    {
      id: 1,
      icon: 'Clock',
      value: '< 2 часа',
      label: 'Среднее время ответа',
      description: 'Мы отвечаем на 95% обращений в течение 2 часов'
    },
    {
      id: 2,
      icon: 'Users',
      value: '5 000+',
      label: 'Довольных клиентов',
      description: 'Компании доверяют нашей поддержке'
    },
    {
      id: 3,
      icon: 'Star',
      value: '4.9/5.0',
      label: 'Рейтинг поддержки',
      description: 'На основе 2 500+ отзывов клиентов'
    },
    {
      id: 4,
      icon: 'CheckCircle',
      value: '98%',
      label: 'Решенных вопросов',
      description: 'С первого обращения без эскалации'
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-primary via-secondary to-primary relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-64 h-64 bg-accent rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-10 right-10 w-80 h-80 bg-purple-500 rounded-full blur-3xl animate-pulse delay-1000"></div>
      </div>
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl lg:text-5xl font-headline font-bold text-white mb-4">
            Поддержка мирового класса
          </h2>
          <p className="text-xl text-gray-200">
            Наша команда экспертов всегда готова помочь вам достичь успеха
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {stats?.map((stat) => (
            <div
              key={stat?.id}
              className="bg-white/10 backdrop-blur-lg border border-white/20 rounded-2xl p-6 hover:bg-white/15 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 rounded-xl bg-accent/20 flex items-center justify-center mb-4">
                <Icon name={stat?.icon} size={28} color="var(--color-accent)" />
              </div>

              <div className="text-4xl font-headline font-bold text-white mb-2">
                {stat?.value}
              </div>

              <div className="text-lg font-semibold text-white mb-2">
                {stat?.label}
              </div>

              <p className="text-sm text-gray-300 leading-relaxed">
                {stat?.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 max-w-4xl mx-auto bg-white/10 backdrop-blur-lg border border-white/20 rounded-2xl p-8">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
            <div className="flex items-center space-x-4">
              <div className="w-16 h-16 rounded-full bg-success/20 flex items-center justify-center">
                <Icon name="Shield" size={32} color="var(--color-success)" />
              </div>
              <div>
                <h3 className="text-xl font-headline font-bold text-white mb-1">
                  Сертифицированная поддержка
                </h3>
                <p className="text-gray-300">
                  Все специалисты прошли обучение и сертификацию
                </p>
              </div>
            </div>

            <div className="flex items-center space-x-6">
              <div className="text-center">
                <div className="text-2xl font-bold text-accent mb-1">24/7</div>
                <div className="text-sm text-gray-300">Доступность</div>
              </div>
              <div className="w-px h-12 bg-white/20"></div>
              <div className="text-center">
                <div className="text-2xl font-bold text-accent mb-1">15+</div>
                <div className="text-sm text-gray-300">Языков</div>
              </div>
              <div className="w-px h-12 bg-white/20"></div>
              <div className="text-center">
                <div className="text-2xl font-bold text-accent mb-1">99.9%</div>
                <div className="text-sm text-gray-300">Uptime</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SupportStats;